import React, { FC, PropsWithChildren } from 'react';

import Tooltip from 'vibo-ui/Tooltip';
import EventTitle from 'components/events/Timeline/EventTitle';

import { useEvent } from 'components/context/EventContext';

import useStyles from './style';

const GeneralInfo: FC<PropsWithChildren> = ({ children }) => {
  const classes = useStyles();

  const { event } = useEvent();

  return (
    <div className={classes.generalInfo}>
      <Tooltip
        overlay={(event?.title?.length ?? 0) > 20 && event?.title}
        type="black"
        placement="top"
      >
        <span>
          <EventTitle name={event?.title} data-hash="eventinput" />
        </span>
      </Tooltip>
      {children}
    </div>
  );
};

export default GeneralInfo;
